import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AppConstants } from '../constant/app.constants';
import { Machine_log } from '../models/index';

@Injectable()
export class Machine_logsService {
  constructor(private http: HttpClient) {
  }

  getMachine_logs(machine_log: Machine_log) {
    return this.http.post<any>(AppConstants.SITE_URL + 'machine_logs/get_machine_logs', machine_log);
  }

  getMachine_logs_excel(machine_log: Machine_log) {
    return this.http.post<any>(AppConstants.SITE_URL + 'machine_logs/get_machine_logs_excel', machine_log);
  }

  getMachine_logs_general(plant_machine) {
    return this.http.post<any>(AppConstants.SITE_URL + 'machine_logs/get_machine_log_general', plant_machine);
  }

  getMachine_logs_trend(plant_machine) {
    return this.http.post<any>(AppConstants.SITE_URL + 'machine_logs/get_machine_log_trend', plant_machine);
  }

  getMachine_logs_trend_excel(plant_machine) {
    return this.http.post<any>(AppConstants.SITE_URL + 'machine_logs/get_machine_log_trend_excel', plant_machine);
  }

  getMachine_logs_alarm(plant_machine) {
    return this.http.post<any>(AppConstants.SITE_URL + 'machine_alarm/get_machine_alarms', plant_machine);
  }

  getMachine_logs_info(plant_machine) {
    return this.http.post<any>(AppConstants.SITE_URL + 'machine_info/get_machine_infos', plant_machine);
  }
}




// WEBPACK FOOTER //
// /var/www/midac/midac-live/app/src/app/services/machine_log.service.ts